// extracted by mini-css-extract-plugin
export default {"title":"CustomEarningsListPage-styles-module--title--RJuiN"};